module.exports = __webpack_public_path__ + "img/ssl.b4c03d01.svg";